module.exports = __webpack_public_path__ + "static/media/sateliteView.1154803d.png";